import script from "./ConfigurationPackageSelectionRequired.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationPackageSelectionRequired.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationPackageSelectionRequired.vue?vue&type=style&index=0&id=57a3ba2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a3ba2b"]])

export default __exports__